import React from "react";
import "./style.css";

const Method = ({ item, selectedMethod, status, onClick }) => {
  return (
    <div className="method_container">
      <div
        className="method_body"
        onClick={onClick}
        style={{ borderColor: selectedMethod?.id == item.id ? "#20C3FF" : "" }}
      >
        <div className="method_info">
          <p>{item.title}</p>
          {status === "in-progress" ? (
            <span className="complete_method_badge">In Progress</span>
          ) : status === "completed" ? (
            <span className="complete_method_badge">Completed</span>
          ) : status === "selected" ? (
            <></>
          ) : (
            // <span className="seleced_method_badge">Selected</span>
            <></>
          )}
        </div>
        <p style={{ fontSize: 12 }}>{item?.description}</p>
      </div>
    </div>
  );
};

export default Method;
